<template>
	<div>
		<!-- begin login-cover -->
		<div class="login-cover">
			<div class="login-cover-image" v-bind:style="{ backgroundImage: 'url('+ bg.activeImg +')' }"></div>
			<div class="login-cover-bg"></div>
		</div>
		<!-- end login-cover -->
		
		<!-- begin login -->
		<div class="login login-v2" data-pageload-addclass="animated fadeIn">
			<!-- begin brand -->
			<div class="login-header">
				<div class="brand">
					<span class="logo"></span> <b>T</b>ELE<b>M</b>ARTIN
					<small>Crecimiento Sin Límites</small>
				</div>
				<div class="icon">
					<i class="fa fa-lock"></i>
				</div>
			</div>
			<!-- end brand -->
			<!-- begin login-content -->
			<div class="login-content">
				<form  method="POST" class="margin-bottom-0">
					<div class="form-group m-b-20">
						<input type="text" v-model.trim="auth.dni"  class="form-control form-control-lg" placeholder="Ingrese su DNI" required />
					</div>
					<div class="form-group m-b-20">
						<input type="password" v-model.trim="auth.clave"  class="form-control form-control-lg" placeholder="Clave" required />
					</div>
					<div class="checkbox checkbox-css m-b-20">
						<input type="checkbox" v-model="auth.recordar_datos" id="remember_checkbox" /> 
						<label for="remember_checkbox">
							Recordar mis datos de acceso
						
						</label>
					</div>
					<div class="login-buttons">
						<button v-show="!updateExists"   type="button" :disabled="validando" @click="loguearse()" class="btn btn-orange btn-block btn-lg">Loguearme</button>
						 
						 <button v-show="updateExists" type="button" class="btn btn-warning btn-block  btn-lg" @click="refreshApp"> 
							 <i class="fa fa-refresh"></i> Existe una nueva versión, haga click para actualizar
						</button>
						 
					</div>
					
					<div v-show="validando" class="m-t-20 text-center">
					Loading...
					
					<div class="spinner-border spinner-border-sm" role="status">
  						<span class="sr-only">Loading...</span>
					</div>
					</div>
				</form>
			</div>
			<!-- end login-content -->
		</div>
		
		<!-- classes="alert alert-dismissible alert-primary rounded  p-5" -->
		<!-- end login -->
		
		<!-- begin login-bg -->
		<!-- <ul class="login-bg-list clearfix">
			<li v-bind:class="{ 'active': bg.bg1.active }"><a href="javascript:;" v-on:click="select('bg1')" style="background-image: url(/assets/img/login-bg/login-bg-17.jpg)"></a></li>
			<li v-bind:class="{ 'active': bg.bg2.active }"><a href="javascript:;" v-on:click="select('bg2')" style="background-image: url(/assets/img/login-bg/login-bg-16.jpg)"></a></li>
			<li v-bind:class="{ 'active': bg.bg3.active }"><a href="javascript:;" v-on:click="select('bg3')" style="background-image: url(/assets/img/login-bg/login-bg-15.jpg)"></a></li>
			<li v-bind:class="{ 'active': bg.bg4.active }"><a href="javascript:;" v-on:click="select('bg4')" style="background-image: url(/assets/img/login-bg/login-bg-14.jpg)"></a></li>
			<li v-bind:class="{ 'active': bg.bg5.active }"><a href="javascript:;" v-on:click="select('bg5')" style="background-image: url(/assets/img/login-bg/login-bg-13.jpg)"></a></li>
			<li v-bind:class="{ 'active': bg.bg6.active }"><a href="javascript:;" v-on:click="select('bg6')" style="background-image: url(/assets/img/login-bg/login-bg-12.jpg)"></a></li>
		</ul> -->
		<!-- end login-bg -->
	</div>
</template>

<script>
import PageOptions from '../config/PageOptions.vue'
import axios from 'axios'
import Vue from 'vue'
import VueJWT from 'vuejs-jwt'
Vue.use(VueJWT)
export default {
	name:'LoginComponent',
	beforeMount(){
		if (this.updateExists) {
        this.refreshApp();
      }

	},
	created() {
		

		this.recordarDatosAcceso();
		PageOptions.pageEmpty = true;
	},
	beforeRouteLeave (to, from, next) {
		PageOptions.pageEmpty = false;
		next();
	},
	data() {
		return {
			validando:false,
            auth:{
				dni:'',
				clave:'',
				recordar_datos:false,
			},
			bg: {
				activeImg: '/app/assets/img/login-bg/login-bg-17.jpg',
				bg1: {
					active: true,
					img: 'app/assets/img/login-bg/login-bg-17.jpg'
				},
			}
		}
	},
	methods: {
		
		loguearse(){
			
			if(!this.auth.dni || !this.auth.clave){
				return this.informacion("Campos incompletos");
			}
			this.validando=true;
			axios.post(this.URL_BASE()+"auth",this.auth).then(respuesta => {
				this.validando=false;
				if(respuesta.data.msg=='exito'){
					this.$store.commit('setToken', respuesta.data.data );
					this.$store.commit('iniciar_sesion');
					
					let a=this.$jwt.decode(respuesta.data.data,this.$store.state.secret_key_token );
					this.$store.commit('setUsuario', a.data );
					this.guardandoDatosAcceso();
					this.iniciarServiciosFijos();
					setTimeout(() => {
						if(this.$store.state.usuario.tipo>=2){
							this.$router.push('/bienvenido'); 	
						}else{
							this.$router.push('/inicio'); 	
						}

						
						
					}, 100);
					
				}else{
					this.advertencia("Usuario o clave incorrectos");
					this.validando=false;
				}
            }).catch( (error)=> {
				this.advertencia('Imposible acceder');
				this.validando=false;
            });
		},
		iniciarServiciosFijos(){
			this.$store.dispatch('getComisionChip');
			this.$store.dispatch('getComisionEquipo');
            this.$store.dispatch('getDepartamentos');
             this.$store.dispatch('getTipoVendedor');
		},
		guardandoDatosAcceso(){
			if(this.auth.recordar_datos){
				localStorage.setItem('recordar',this.auth.recordar_datos);
				localStorage.setItem('usuario',this.auth.dni);
				localStorage.setItem('clave',this.auth.clave);
			}else{
				localStorage.setItem('recordar','');
				localStorage.setItem('usuario','');
				localStorage.setItem('clave','');
				
			}
		},
		recordarDatosAcceso(){
			let recordar=localStorage.getItem('recordar');
			this.auth.recordar_datos=recordar!=''  ? true : false;
			this.auth.dni=localStorage.getItem('usuario');
			this.auth.clave=localStorage.getItem('clave');
		}
		
	}
}
</script>